module.exports = __webpack_public_path__ + "static/media/dp.ae3e1077.jpeg";